import { z } from 'zod';
import { requiredString } from '../helpers';
export const Guidewire_Submit_Claim_1_ConfigValidator = z.object({
    claimType: z.enum(['auto', 'home'], {
        error: (issue) => issue.input === undefined ? 'Claim type is required' : 'Claim type must be either "auto" or "home"'
    }),
    claim: z.union([z.record(z.string(), z.unknown()), requiredString('Claim data is required')])
});
//# sourceMappingURL=guidewire-submit-claim-1.js.map